import { render, staticRenderFns } from "./text-area-field.vue?vue&type=template&id=d27e9d3a&"
import script from "./text-area-field.vue?vue&type=script&lang=js&"
export * from "./text-area-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports